'use client'

import DocPage from './DocPage'

export default function Payment({ vendor }: { vendor?: any }) {
  return (
    <DocPage
      vendor={vendor}
      pageKey="payment"
      title="Төлбөрийн нөхцөл"
      description="Дэмжигдсэн төлбөрийн арга, гүйлгээний зөвлөмж, баталгаажуулалттай холбоотой нөхцөлүүдийг доороос уншина уу."
      htmlContent={vendor?.terms?.payment}
      emptyMessage="Одоогоор төлбөрийн нөхцөл нэмэгдээгүй байна."
    />
  )
}
